import React from 'react';
import { Divider, Card } from 'semantic-ui-react';

import ReceivedEmail from './../../ReceivedEmail';
import ConfirmationModal from '../../modals/ConfirmationModal';
import PathView from '../../PathView';
import Content from '../../Content';
import TaskContainer from '../../TaskContainer';
import getTaskTitle from '../../../utils/getTaskTitle';
import ClaimSearch from './ClaimSearch';

const TaskView = ({
  task,
  emailMessage,
  claimToAssign,
  isConfirmationOpen,
  loading,
  onConfirmation,
  onAssignClick,
  onReject
}) => {
  return (
    <Content fullWidth>
      <PathView
        paths={[
          { name: 'Tasks', path: '/tasks' },
          { name: task.id, path: `/task/${task.id}` }
        ]}
      />
      <TaskContainer
        title={getTaskTitle(task)}
        date={task.createdAt}
        id={task.id}
        priority={task.priority}
        icon="hashtag"
        loading={loading}
        hideClaim
      >
        <ConfirmationModal
          question={`Are you sure you want to assign The email to claim with id ${claimToAssign}?`}
          isOpen={isConfirmationOpen}
          onConfirmation={onConfirmation}
        />
        <Card.Description>
          <ReceivedEmail email={emailMessage} toggleImportLabel={true} />
        </Card.Description>
        <Divider hidden />
        <ClaimSearch onAssignClick={onAssignClick} onReject={onReject}/>
      </TaskContainer>
    </Content>
  );
};

export default TaskView;



// WEBPACK FOOTER //
// ./src/component/tasks/AssignMessageTask/TaskView.js